//Y Label detailed function
export function labeledYAxis(selection, props) {
  const {
    yAxisLabelFill,
    yAxisLabelOffset,
    yAxisTickFontSize,
    yAxisLabelFontSize,
    AxisTickFontFill,
    AxisTickLineStroke,
    AxisDomainLineStroke,
    yAxisTickDensity,
    yScale,
    innerHeight,
  } = props;

  const yAxis = d3
    .axisLeft(yScale)
    .ticks(innerHeight / yAxisTickDensity)
    .tickSizeOuter(0);

  let yAxisG = selection.selectAll(".AxisY").data([null]);
  yAxisG = yAxisG.enter().append("g").attr("class", "AxisY").merge(yAxisG);
  yAxisG.call(yAxis);
  yAxisG
    .selectAll(".tick text")
    .attr("font-size", yAxisTickFontSize)
    .attr("fill", AxisTickFontFill);

  yAxisG
    .selectAll(".tick line")
    .attr("stroke", AxisTickLineStroke)
    .attr("display", "none");
  yAxisG.select(".domain").attr("stroke", AxisDomainLineStroke);

  //const labels = yAxisG.selectAll('.tick');
  //yAxisG.selectAll('.tick').call(wrap);

  //Labels
  // const yAxisLabel = yAxisG.selectAll('.axisLabelY').data([null]);
  // yAxisLabel.enter().append('text')
  // 	.attr('class', 'axisLabelY')
  // 	.merge(yAxisLabel)
  // 		.text('Data value (%)')
  // 		.attr('fill', yAxisLabelFill)
  // 		.attr('x', -innerHeight / 2 + 224)
  // 		.attr('y', -yAxisLabelOffset)
  // 		.attr('transform', 'rotate(-90)')
  // 		.style('font-size', yAxisLabelFontSize);
}
